import { render } from "./EditReviewModalComponent.vue?vue&type=template&id=34a45888&scoped=true"
import script from "./EditReviewModalComponent.vue?vue&type=script&lang=js"
export * from "./EditReviewModalComponent.vue?vue&type=script&lang=js"

import "./EditReviewModalComponent.vue?vue&type=style&index=0&id=34a45888&scoped=true&lang=css"

import exportComponent from "C:\\Users\\epentilescu\\source\\repos\\Delicitate V2\\front-end\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a45888"]])

export default __exports__